import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { AxiosResponse } from 'axios';
import { TypeOperationData } from 'shell/models/type-operation';
import { memo, useEffect } from 'react';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface ListTypeOperationProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  tyPractice?: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  typeRegister?: string;
}

const ListTypeOperationComponent = ({
  disabled,
  required,
  tyPractice,
  onChange,
  value,
  error,
  typeRegister,
}: ListTypeOperationProps): React.ReactElement => {
  const [list, getList] = useHttpFetch<HttpResponseList<TypeOperationData>, Array<ItemVM>>(
    `${__PRACTICE_API_URL__}/pratiche/tipo-operazione`,
    {
      onBootstrap: false,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (response: AxiosResponse<HttpResponseList<TypeOperationData>>) => {
        const { data } = response;
        return data?.payload?.list?.map((item) => ({
          id: item.key?.tipoOperazione || '',
          // value:
          //   `${item?.key?.tipoPratica}/${item.key?.tipoOperazione}/${item.descrizioneBreveTipoOperazione}` ||
          //   '',
          value: item.descrizioneBreveTipoOperazione || '',
        }));
      },
    }
  );

  useEffect(() => {
    const data = {
      tipoPratica: { value: tyPractice || '', operation: Operation.EQUALS },
    };

    const queryParams = tyPractice
      ? `${paginationListToQueryString({
          filters: data,
          orders: {},
        })}`
      : '';
    if (!typeRegister && tyPractice) {
      return;
    }
    getList({
      params: {},
      paramsSerializer: () => queryParams,
      url: typeRegister ? `/tipo-registro/${typeRegister}` : undefined,
    });
  }, [tyPractice, typeRegister]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id="type-label">
        {required ? 'Tipo di operazione *' : 'Tipo di operazione'}
      </InputLabel>
      <PmiSelect
        labelId="type-label"
        id="type-operation"
        name="type-operation"
        value={value}
        label={required ? 'Tipo di operazione *' : 'Tipo di operazione'}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(list.data as Array<ItemVM>)?.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListTypeOperationComponent.displayName = 'List type component';

const ListTypeOperation = memo(ListTypeOperationComponent);

export default ListTypeOperation as typeof ListTypeOperationComponent;
